import axios from "axios";
import { handleJWT, rmStorageAndReload } from "./handleJWT";

const SERVER_URL = `${process.env.REACT_APP_SITEURL}/leitner`;

const getWordLearningListByLangApi = async (data, paginate) => {
  try {
    const url = `${SERVER_URL}/api/v1/leitner/getWordLearningListByLang?limit=${paginate.perPage || 50
      }&page=${paginate.page || 1}`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.post(url, data, {
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await getWordLearningListByLangApi(data, paginate)
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error)
      throw error
    }
  }
};

const getReadyWordLearningListByLangApi = async (data, paginate) => {
  try {
    const url = `${SERVER_URL}/api/v1/leitner/getReadyWordLearningListByLang?limit=${paginate.perPage || 50
      }&page=${paginate.page || 1}`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.post(url, data, {
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await getReadyWordLearningListByLangApi(data, paginate)
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error)
      throw error
    }
  }
};

const addBoxApi = async (data) => {
  try {
    const url = `${SERVER_URL}/api/v1/leitner/addBox`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.post(url, data, {
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await addBoxApi(data)
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error)
      throw error
    }
  }
};

const addCardsFromSaveWordsApi = async (data) => {
  try {
    const url = `${SERVER_URL}/api/v1/leitner/addCardsFromSaveWords`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.post(url, data, {
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await addCardsFromSaveWordsApi(data)
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error)
      throw error
    }
  }
};

const getBoxesListApi = async (data) => {
  try {
    const url = `${SERVER_URL}/api/v1/leitner/BoxesList`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.post(url, data, {
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await getBoxesListApi(data)
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error)
      throw error
    }
  }
};

const showDetailsBox = async (data, paginate) => {
  try {
    const url = `${SERVER_URL}/api/v1/leitner/showDetailsBox?limit=${paginate.perPage || 50
      }&page=${paginate.page || 1}`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.post(url, data, {
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await showDetailsBox(data, paginate)
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error)
      throw error
    }
  }
};

const answerCardApi = async (data) => {
  try {
    const url = `${SERVER_URL}/api/v1/leitner/answerCard`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.patch(url, data, {
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await answerCardApi(data)
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error)
      throw error
    }
  }
};

const editBoxApi = async (data) => {
  try {
    const url = `${SERVER_URL}/api/v1/leitner/editBox`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.patch(url, data, {
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await editBoxApi(data)
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error)
      throw error
    }
  }
};

const editCardApi = async (data) => {
  try {
    const url = `${SERVER_URL}/api/v1/leitner/editCard`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.patch(url, data, {
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await editCardApi(data)
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error)
      throw error
    }
  }
};

const deleteCardApi = async (dataObject) => {
  try {
    const url = `${SERVER_URL}/api/v1/leitner/deleteCard`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.delete(url, {
      data: dataObject,
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await deleteCardApi(dataObject)
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error)
      throw error
    }
  }
};

const deleteBoxApi = async (dataObject) => {
  try {
    const url = `${SERVER_URL}/api/v1/leitner/deleteBox`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.delete(url, {
      data: dataObject,
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await deleteBoxApi(dataObject)
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error)
      throw error
    }
  }
};

export {
  getWordLearningListByLangApi,
  getReadyWordLearningListByLangApi,
  addBoxApi,
  addCardsFromSaveWordsApi,
  getBoxesListApi,
  showDetailsBox,
  answerCardApi,
  editBoxApi,
  deleteBoxApi,
  editCardApi,
  deleteCardApi,
};
